import { ContaCorrenteModel } from "./conta-corrente.model";
import { FormaPagamentoModel } from "./forma-pagamento.model";

export class ModoPagamentoContaModel {
  id?: number;
  formaPagamentoId?: number;
  contaCorrenteId?: number;
  observacao?: string;
  provedor?: string;
  integracao?: boolean;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  formaPagamento?: FormaPagamentoModel;
  contaCorrente?: ContaCorrenteModel;

  constructor(options: ModoPagamentoContaModel = {}) {
    this.id = options.id || null;
    this.formaPagamentoId = options.formaPagamentoId || null;
    this.contaCorrenteId = options.contaCorrenteId || null;
    this.observacao = options.observacao || null;
    this.provedor = options.provedor || null;
    this.integracao = options.integracao || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.formaPagamento = options.formaPagamento || new FormaPagamentoModel();
    this.contaCorrente = options.contaCorrente || new ContaCorrenteModel();
  }
}
